// Mirror of the relevant fields from /specs/data-model.md `User`.
// The admin dashboard only consumes them; full CRUD lives on the server.

// Mayusculas para alinear con el enum de Prisma en el backend.
export type UserRole = 'ALUMNO' | 'DOCENTE' | 'ADMIN'

/** Roles con acceso al admin dashboard (staff). Ver specs/docente-fichas.md "Permisos". */
export function isStaffRole(rol: UserRole): boolean {
  return rol === 'ADMIN' || rol === 'DOCENTE'
}

export interface AdminUser {
  id: string
  email: string
  nombre: string
  apellido: string
  rol: UserRole
  activeUntil: string | null
  // Permiso para publicar fichas (staff). Un DOCENTE sin permiso solo guarda
  // borradores; un ADMIN publica siempre. Ver specs/docente-fichas.md.
  canPublishFichas: boolean
}

// Wire format de POST /auth/session:
// - 200 OK: AdminUser plano (usuario existente).
// - 201 Created: { needsProfile: true, ... } (admin nunca deberia ver esto en prod
//   porque el seed crea la fila de DB; si ocurre, el login flow rechaza).
export type AuthSessionResponse =
  | { needsProfile: true; email?: string; nombre?: string; apellido?: string }
  | (AdminUser & { needsProfile?: undefined })
